import React from 'react';
import './OrientationOverlay.css';

/**
 * Full-screen "rotate your device" overlay. The viewer is landscape-only on
 * phones; on iOS (no orientation lock API) this overlay IS the mechanism —
 * it blocks all input while in portrait.
 */
const OrientationOverlay = ({ show }) => {
  if (!show) return null;
  return (
    <div className='orientation-overlay' role='alert'>
      <div className='orientation-overlay__phone'>
        <i className='fas fa-mobile-alt' aria-hidden='true'></i>
      </div>
      <div className='orientation-overlay__title'>Rotate your device</div>
      <div className='orientation-overlay__hint'>
        The 3D viewer works in landscape mode
      </div>
    </div>
  );
};

export default OrientationOverlay;
